import GenericService from 'services/genericService';
import { getPostpaidServices } from 'utils/api/queries/wcm';
import { getAdminOnTheGoNewServices } from 'utils/api/queries/wcm';

export class ShortcutService extends GenericService {
	public static getPostpaidServices() {
		return getPostpaidServices()
			.withErrorHandling()
			.call();
	}
	public static getAdminOnTheGoNewServices() {
		return getAdminOnTheGoNewServices()
			.withErrorHandling()
			.call();
	}
}
